import "core-js/modules/es6.object.define-property";

/**
 * Helper class used to generate session unique ID
 */
var UniqueIdGenerator =
/** @class */
function () {
  function UniqueIdGenerator() {}

  Object.defineProperty(UniqueIdGenerator, "UniqueId", {
    /**
     * Gets an unique (relatively to the current scene) Id
     */
    get: function get() {
      var result = this._UniqueIdCounter;
      this._UniqueIdCounter++;
      return result;
    },
    enumerable: true,
    configurable: true
  }); // Statics

  UniqueIdGenerator._UniqueIdCounter = 0;
  return UniqueIdGenerator;
}();

export { UniqueIdGenerator };